module.exports = __webpack_public_path__ + "img/categorie-cave-famille-boutrais-big.3470323b.jpg";